import React from 'react';
import {
  Grid,
  Typography,
  makeStyles,
  Theme,
  createStyles,
  Divider,
  colors,
} from '@material-ui/core';
import {
  mdiPhone,
  mdiBook,
  mdiCar,
  mdiParking,
  mdiAccountBox,
  mdiBox,
  mdiPackage,
  mdiPackageVariant,
  mdiPackageVariantClosed,
} from '@mdi/js';
import Icon from '@mdi/react';
import {translate} from '../../../utils/helpers';

//Styles
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    infoIcon: {
      color: 'inherit',
    },
    infoSection: {
      color: '#2f4858',
      padding: '8px',
    },
    infoBar: {
      flexShrink: 1,
      display: 'inline',
    },
    namePlateText: {
      paddingLeft: '8px',
      fontSize: '18px',
    },
    namePlateNumber: {
      paddingLeft: '8px',
      fontSize: '14px',
    },
    namePlate: {
      flexShrink: 1,
      display: 'flex',
      flexDirection: 'column',
      paddingBottom: '8px',
    },
    parentGrid: {
      minWidth: '100%',
      backgroundColor: 'white',
      padding: '0px',
      marginTop: '12px',
    },
    idBar: {
      display: 'flex',
      padding: '10px',
    },
    profileImage: {
      maxWidth: '48px',
      maxHeight: '48px',
      borderRadius: '50%',
    },
    root: {
      marginTop: '30px',
    },

    driverMobView: {
      paddingLeft: '0px',
    },
    tabs: {
      zIndex: 12,
      boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.08)',
      position: 'fixed',
      top: '56px',
      right: '0',
      borderBottom: '1',
      borderColor: '#000',
      width: '100%',
      backgroundColor: '#fff',
    },
    pelak: {
      padding: '5px 5px 5px 0',
      border: '1px solid #BDBDBD',
      borderRadius: '2px',
      marginLeft: '20px',
    },
    status: {
      padding: '0 10px',
    },
    LOADED: {
      border: '1px solid #12B42B',
      borderRadius: '4px',
      backgroundColor: '#E8FAEB',
      color: '#12B42B',
      padding: '12px',
      margin: '12px 0 16px',
    },
    EXITED: {
      border: '1px solid #12B42B',
      borderRadius: '4px',
      backgroundColor: '#E8FAEB',
      color: '#12B42B',
      padding: '12px',
      margin: '12px 0 16px',
    },
    ENTERED: {
      border: '1px solid #0085FF',
      borderRadius: '4px',
      backgroundColor: '#E8F3FA',
      color: '#0085FF',
      padding: '12px',
      margin: '12px 0 16px',
    },
    WAITING: {
      border: '1px solid #FFB800',
      borderRadius: '4px',
      backgroundColor: '#E8FAEB',
      color: '#FFB800',
      padding: '12px',
      margin: '12px 0 16px',
    },
  })
);

export const HistoryCard = (props: any) => {
  const classes = useStyles();

  const vehicle = props.vehicle;

  return (
    <React.Fragment>
      {
        <Grid item className={classes.parentGrid} direction="column">
          <Grid item xs={12} spacing={1} className={classes.idBar}>
            <Grid item className={classes.namePlate}>
              <Typography variant="body1" className={classes.namePlateText}>
                {vehicle.driverName}
              </Typography>
              <Typography
                variant="subtitle2"
                className={classes.namePlateNumber}
              >
                {vehicle.driverId}
              </Typography>
            </Grid>
          </Grid>
          <Divider />
          <Grid container className={classes.status}>
            <Grid
              item
              xs={12}
              spacing={1}
              className={classes[vehicle.newStatus]}
            >
              <Typography variant="body1">
                {translate(vehicle.newStatus, 'driver')}
              </Typography>
            </Grid>
          </Grid>

          <Grid container className={classes.infoSection}>
            <Grid item xs={2} spacing={1} className={classes.infoBar}>
              <Icon path={mdiPhone} size={1} className={classes.infoIcon} />
            </Grid>

            <Grid item xs={4} spacing={1} className={classes.infoBar}>
              <Typography variant="body1">
                {vehicle.driverMobileNumber}
              </Typography>
            </Grid>
            
          </Grid>
          <Grid container className={classes.infoSection}>
            <Grid item xs={2} spacing={1} className={classes.infoBar}>
              <Icon path={mdiBook} size={1} className={classes.infoIcon} />
            </Grid>

            <Grid item xs={4} spacing={1} className={classes.infoBar}>
              <Typography variant="body1">{vehicle.fleetName}</Typography>
            </Grid>
          </Grid>
          <Grid container className={classes.infoSection}>
            <Grid item xs={2} spacing={1} className={classes.infoBar}>
              <Icon path={mdiParking} size={1} className={classes.infoIcon} />
            </Grid>

            <Grid item xs={4} spacing={1} className={classes.infoBar}>
              <Typography variant="body1">
                پارکینگ {vehicle.parkingNumber}
              </Typography>
            </Grid>
          </Grid>
          <Grid container className={classes.infoSection}>
            <Grid item xs={2} spacing={1} className={classes.infoBar}>
              <Icon
                path={mdiPackageVariantClosed}
                size={1}
                className={classes.infoIcon}
              />
            </Grid>

            <Grid item xs={4} spacing={1} className={classes.infoBar}>
              <Typography variant="body1">
                {vehicle.bundleOrdersCount} بسته
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      }
    </React.Fragment>
  );
};
//
// <Grid item xs={4} spacing={1} className={classes.infoBar}>
//   <Typography variant="body1">{vehicle.driverMobileNumber}</Typography>
// </Grid>

// <Grid item xs={10} spacing={1} className={classes.infoBar}>
//   <span>{vehicle.vehicleType}</span>
//   <span className={classes.pelak}>
//     <span style={{ borderLeft: "1px solid #BDBDBD", padding: "5px" }}>{vehicle.vehiclePlateNumber.substring(7)}</span> {vehicle.vehiclePlateNumber.substring(3, 6)} {vehicle.vehiclePlateNumber.substring(2, 3)} {vehicle.vehiclePlateNumber.substring(0, 2)}
//   </span>
// </Grid>

// <Grid item xs={4} spacing={1} className={classes.infoBar}>
//   <Typography variant="body1">{vehicle.bundleOrdersCount} بسته</Typography>
// </Grid>
